/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UnknownPayload
 */
export interface UnknownPayload {
    [key: string]: any | any;
    /**
     * 
     */
    type: UnknownPayloadTypeEnum;
    /**
     * 
     */
    originalType: string;
    /**
     * 
     */
    raw: { [key: string]: any; };
}


/**
 * @export
 */
export const UnknownPayloadTypeEnum = {
    Unknown: 'unknown',
} as const;
export type UnknownPayloadTypeEnum = typeof UnknownPayloadTypeEnum[keyof typeof UnknownPayloadTypeEnum];


/**
 * Check if a given object implements the UnknownPayload interface.
 */
export function instanceOfUnknownPayload(value: object): value is UnknownPayload {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (value['type'] !== 'unknown') return false;
    
    if ((!('originalType' in (value as Record<string, any>)) && !('original_type' in (value as Record<string, any>))) || ((value as Record<string, any>)['originalType'] === undefined && (value as Record<string, any>)['original_type'] === undefined)) return false;
    if (!('raw' in value) || value['raw'] === undefined) return false;
    return true;
}

export function UnknownPayloadFromJSON(json: any): UnknownPayload {
    return UnknownPayloadFromJSONTyped(json, false);
}

export function UnknownPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnknownPayload {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'type': json['type'],
        'originalType': json['original_type'],
        'raw': json['raw'],
    };
}

export function UnknownPayloadToJSON(json: any): UnknownPayload {
    return UnknownPayloadToJSONTyped(json, false);
}

export function UnknownPayloadToJSONTyped(value?: UnknownPayload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'type': value['type'],
        'original_type': value['originalType'],
        'raw': value['raw'],
    };
}

